import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

class BhlProductAddons extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleAdd);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleAdd);
  }

  #handleAdd = async (event) => {
    const button = event.target.closest('[data-addon-variant]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const originalMarkup = button.innerHTML;
    const originalLabel = button.getAttribute('aria-label');
    const variantId = button.dataset.addonVariant;
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', [...new Set(sectionIds)].join(','));
    body.append('sections_url', window.location.pathname);

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || 'Unable to add accessory');

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const ajaxCart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          didError: false,
          itemCount: 1,
          items: ajaxCart.items,
          sections: added.sections,
          source: 'bhl-product-addons',
        },
      });

      const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (typeof cartDrawer?.open === 'function') {
        cartDrawer.open();
      } else {
        document.querySelector('[aria-controls="cart-drawer"]')?.click();
      }

      button.innerHTML = '<span aria-hidden="true">✓</span>';
      button.setAttribute('aria-label', 'Added to cart');
      window.setTimeout(() => {
        button.innerHTML = originalMarkup;
        if (originalLabel) button.setAttribute('aria-label', originalLabel);
        button.disabled = false;
      }, 2200);
    } catch (error) {
      deferred.resolve({
        cart: null,
        detail: { didError: true, itemCount: 0, source: 'bhl-product-addons' },
      });
      this.dispatchEvent(
        new CartErrorEvent({
          error: error?.message || 'Unable to add accessory',
          code: 'INVALID',
        })
      );
      button.innerHTML = '<span aria-hidden="true">!</span>';
      window.setTimeout(() => {
        button.innerHTML = originalMarkup;
        button.disabled = false;
      }, 1800);
    } finally {
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('bhl-product-addons')) {
  customElements.define('bhl-product-addons', BhlProductAddons);
}
